<template>
  <transition name="popover">
    <div class="loading-wrapper" :style="{'background-color': bg}">
      <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path" :stroke="circle_color"></circle></svg>
    </div>
  </transition>
</template>

<script type='text/ecmascript-6'>
export default {
  props: {
    bg: {
      type: String,
      default: '#FFFFFF'
    },
    circle_color: {
      type: String,
      default: '#64696E'
    }
  },
  data () {
    return {}
  },
  mounted () {},
  methods: {}
}
</script>

<style lang='less' scoped>
.loading-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  .circular {
    width: 56px;
    height: 56px;
    animation: loading-rotate 2s linear infinite;
    .path {
      animation: loading-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90,150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      // stroke: #E89E25;
      stroke-linecap: round;
    }
  }
}
@keyframes loading-rotate {
	to {
		transform: rotate(1turn);
	}
}
@keyframes loading-dash {
	0% {
		stroke-dasharray: 1,200;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 90,150;
		stroke-dashoffset: -40px;
	}
	to {
		stroke-dasharray: 90,150;
		stroke-dashoffset: -120px;
	}
}
.popover-enter-active, .popover-leave-active {
  transition: all .16s ease-in-out;
  opacity: 1;
}
.popover-enter, .popover-leave-to {
  opacity: 0;
}
</style>